export default __webpack_public_path__ + "static/media/object--phone-booth.b2671fc0.png";